import { TranslateService } from '@ngx-translate/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Component, OnInit } from '@angular/core';
import { TipoInmuebleService } from '../../services/tipo-inmueble.service';
import { Router, ActivatedRoute } from '@angular/router';
import { FormControl } from '@angular/forms';
import { CellDateFormatterComponent } from '../cell-date-formatter/cell-date-formatter.component';
import { TipoInmuebleEditComponent } from '../tipo-inmueble-edit/tipo-inmueble-edit.component';


@Component({
  selector: 'app-tipo-inmmueble',
  templateUrl: './tipo-inmmueble.component.html',
  styleUrls: ['./tipo-inmmueble.component.scss']
})
export class TipoInmmuebleComponent implements OnInit {

  public columnDefs: any[];
  dialogConfig: MatDialogConfig;
  private gridApi: any;
  public rowData: any;
  searchTerm: FormControl = new FormControl();
  isCheckedDisabled: boolean = false;

  public defaultColDef = {
    // set every column width
    width: 100,
    // make every column editable
    // make every column use 'text' filter by default
    filter: 'agTextColumnFilter'
  };

  constructor(private _tipoinmuebleservice: TipoInmuebleService, private _router: Router, private _route: ActivatedRoute,
      private _dialog: MatDialog, private translate: TranslateService) {

    this.columnDefs = this.createColumnDef();
    this.dialogConfig = new MatDialogConfig();
    this.dialogConfig.disableClose = false;
    this.dialogConfig.autoFocus = true;
    this.dialogConfig.closeOnNavigation = true;

  }

  ngOnInit() {
    this.getData();
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridApi.sizeColumnsToFit();
  }

  getData() {
    this._tipoinmuebleservice.getTipoInmuebles(this.isCheckedDisabled).subscribe(data => this.rowData = data);
  }


  createColumnDef() {
    const columnDefs = [
      { headerName: 'ID', field: 'id', cellClass: 'grid-opendialog', minWidth: 150 },
      { headerName: 'Nombre', field: 'nombre', cellClass: 'grid-opendialog', minWidth: 150 },
      { headerName: 'Actualizado por', field: 'updatedByName', minWidth: 150 },
      { headerName: 'Fecha actualización', field: 'updatedDate', minWidth: 150, cellRendererFramework: CellDateFormatterComponent },
      { headerName: 'Creado por', field: 'createdByName', minWidth: 150 },
      { headerName: 'Fecha de creación', field: 'createdDate', minWidth: 150, cellRendererFramework: CellDateFormatterComponent },
      {
        headerName: 'Deshabilitado', field: 'disabled', minWidth: 150, valueFormatter: function (params) {
          return params.value ? 'Sí' : 'No';
        }
      }
    ];
    return columnDefs;
  }

  public newItem() {

    const ref = this._dialog.open(TipoInmuebleEditComponent, this.dialogConfig);
    ref.componentInstance.isModal = true;
    ref.componentInstance.id = '0';
    ref.afterClosed().subscribe(result => {
      this.getData();
    });

  }

  public onCellClickedEvent($event) {

    if ($event.colDef.cellClass !== undefined && $event.colDef.cellClass.indexOf('grid-opendialog') >= 0) {

      const dlgRef = this._dialog.open(TipoInmuebleEditComponent, this.dialogConfig);
      dlgRef.componentInstance.id = $event.data.id;
      dlgRef.componentInstance.isModal = true;
      dlgRef.componentInstance.editForm.controls['id'].disable();
      dlgRef.afterClosed().subscribe(result => {
        this.getData();
      });
    }
  }

  showDisabled() {
    this.getData();
  }
}
